import PropTypes from 'prop-types';
import {React} from 'react';
import { useTranslation } from 'react-i18next';
import RadioButtonGroup from '../../../../core/components/radio-button-group/radio-button-group';
import { TwoChoicesButtons } from '../../../../core';
import ObservationCarSelector from './observation-car-selector/observation-car-selector';
import ObservationCheckbox from './observation-checkbox/observation-checkbox';
import ObservationComment from './observation-comment/observation-comment';
import ObservationDelay from './observation-delay/observation-delay';
import {
  carSelector,
  carSelectorWithInput,
  checkbox,
  comment,
  dateTime,
  delay,
  fileAttachment,
  radio,
  reminderText,
  stationSearch,
  text,
  trainStorageSearch,
  yesNo,
} from './observation-fields-list';
import './observation-fields.scss';
import ObservationReminderText from './observation-reminder-text/observation-reminder-text';
import ObservationSearch from './observation-search/observation-search';
import ObservationText from './observation-text/observation-text';
import ObservationTime from './observation-time/observation-time';
import ObservationWithFileAttachment from './observation-with-file-attachment/observation-with-file-attachment';


const ObservationFields = (props) => {
  

  
  const { t } = useTranslation();
  const {
    line,
    fieldSchema,
    fieldName,
    state,
    handleChange,
    mandatory,
    validator,
    repeat,
    setTimeError,
    driveLog,
    observationFiles,
    setObservationFiles,
    observationId,
    maxLength,
  } = props;

  const materialType = props?.allFields?.materialType?.value ?? props?.allFields?.materialType;
 

  const labelBase = repeat
    ? t(`observation:observation-fields.${fieldName}-repeat`)
    : t(`observation:observation-fields.${fieldName}`);
  const optionalLabel = mandatory ? '' : t('observation:observation-fields.optional');
  const label = `${labelBase} ${optionalLabel}`;
  const className = `observation__field observation__field--${fieldName}`;

  const getListType = (name) => {
    if (name === 'car') return line;
    if (name === 'equipment') {
      if (line === 'A') return 'equipmentA';
      if (line === 'B') return 'equipmentB';
      return 'equipmentNight';
    }
    return name;
  };


  
  if (fieldName === 'materialType') {
    const optionalLabel = mandatory ? '' : t('observation:observation-fields.optional');
    const fieldLabel = t('observation:observation-fields.' + fieldName);
    const label = fieldLabel + ' ' + optionalLabel;
    return (
      <div className="observation__field observation__field--materialType">
           <h3 className="observation__field__label">{label}</h3>
        <RadioButtonGroup
          selectedValue={state}
          onChange={handleChange}
        
          options={[
            { label: 'MI09 / MI2N', value: 'MI09_MI2N' },
            { label: 'MI79 R / MI84 R', value: 'MI79_MI84R' },
            { label: 'MI84', value: 'MI84' },
          ]}
        />
      </div>
    );
  }

 
  if (fieldName === 'cassetteInstalled' && materialType === 'MI84') {
    return null;
  }
  

  if (fieldName === 'cassetteNoted') {

    const isMI84 = materialType === 'MI84';
    const dynamicLabel = isMI84
      ? t('observation:observation-fields.tachy-label')
      : t('observation:observation-fields.cassetteNoted');
  
    const dynamicPlaceholder = isMI84
      ? t('observation:observation-fields.tachy-placeholder')
      : t('observation:observation-fields.cassetteNoted-placeholder');
  
    return (
      <div className="observation-text observation__field observation__field--cassetteInstalled">
          <label className="cassette-custom-label">
            {dynamicLabel}
          </label>
      <ObservationComment
        className={`${className} cassetteNoted--textarea-fix hide-comment-label`}
        value={state}
        title=""
        handleChange={handleChange}
        placeholder={dynamicPlaceholder}
        validator={validator}
        maxLength={maxLength}
        fieldSchema={fieldSchema}
      /></div>
    );
  }

  if (fieldName === 'period') {
  
    if (!materialType) return null;
    const listType = {
      MI09_MI2N: 'period_MI09_MI2N',
      MI79_MI84R: 'period_MI79_MI84R',
      MI84: 'period_MI84',
    }[materialType];

    return (
      <div className="observation__field observation__field--period">
         <ObservationCarSelector
      className={className}
      label={label}
      value={state}
      handleChange={handleChange}
      listType={listType}
      fieldSchema={fieldSchema}
    />
      </div>
    );
  }

  
  if (carSelector.includes(fieldName)) {
    return (
      <ObservationCarSelector
        className={className}
        label={label}
        value={state}
        handleChange={handleChange}
        listType={getListType(fieldName)}
        fieldSchema={fieldSchema}
      />
    );
  }

  if (carSelectorWithInput.includes(fieldName)) {
    return (
      <ObservationCarSelector
        className={className}
        label={label}
        value={state}
        handleChange={handleChange}
        listType={getListType(fieldName)}
        hasInput
        inputPlaceholder={t(`observation:observation-fields.${fieldName}-placeholder`)}
        fieldSchema={fieldSchema}
      />
    );
  }

  if (stationSearch.includes(fieldName) || trainStorageSearch.includes(fieldName)) {
    const referential = (stationSearch.includes(fieldName) && 'station') ||
                        (trainStorageSearch.includes(fieldName) && 'train-storage');
                        
    return (
      <ObservationSearch
        key={state ? state.key || state.name : 'empty'}
        className={className}
        line={driveLog?.line_number}
        searchLabel={label}
        referential={referential}
        selectedStation={state}
        setSelectedStation={handleChange}
        fieldSchema={fieldSchema}
      />
      
    );
  }


  if (text.includes(fieldName)) {
    return (
      <ObservationText
        className={className}
        label={label}
        value={state}
        onChange={handleChange}
        placeholder={t(`observation:observation-fields.${fieldName}-placeholder`)}
        validator={validator}
        fieldSchema={fieldSchema}
      />
    );
  }

  if (comment.includes(fieldName)) {
    return (
      <ObservationComment
        className={className}
        value={state}
        title={label}
        handleChange={handleChange}
        placeholder={t(`observation:observation-fields.${fieldName}-placeholder`)}
        validator={validator}
        maxLength={maxLength}
        fieldSchema={fieldSchema}
      />
    );
  }


  if (fileAttachment.includes(fieldName)) {
    return (
      <ObservationWithFileAttachment
        driveLogId={driveLog?.id}
        observationFiles={observationFiles}
        setObservationFiles={setObservationFiles}
        observationId={observationId}
      />
    );
  }

  if (yesNo.includes(fieldName)) {
    return (
      <TwoChoicesButtons
        className={className}
        name={fieldName}
        value={state}
        onChange={handleChange}
        label={label}
        firstOptionLabel={t('observation:observation-fields.radio-button.yes')}
        firstOptionValue="yes"
        secondOptionLabel={t('observation:observation-fields.radio-button.no')}
        secondOptionValue="no"
        fieldSchema={fieldSchema}
      />
    );
  }

  if (radio.includes(fieldName)) {
    const firstOption =
      (fieldName === 'garageAction' && 'garage') ||
      (fieldName === 'pcc' && 'sncf') ||
      (fieldName === 'authorizationType' && 'resume-running');
    const secondOption =
      (fieldName === 'garageAction' && 'deGarage') ||
      (fieldName === 'pcc' && 'creg') ||
      (fieldName === 'authorizationType' && 'crossing-signal');
    return (
      <TwoChoicesButtons
        className={className}
        name={fieldName}
        value={state}
        onChange={handleChange}
        label={label}
        firstOptionLabel={t(`observation:observation-fields.radio-button.${firstOption}`)}
        firstOptionValue={firstOption}
        secondOptionLabel={t(`observation:observation-fields.radio-button.${secondOption}`)}
        secondOptionValue={secondOption}
        fieldSchema={fieldSchema}
      />
    );
  }

  if (dateTime.includes(fieldName)) {
  
        
    return (
      <ObservationTime
        className="observation__field"
        label={label}
        dateTime={state}
        handleChange={handleChange}
        setTimeError={setTimeError}
        fieldSchema={fieldSchema}
        startServiceDateTime={driveLog?.realized_date_start}
      />
    );
  }

  if (fieldName === 'duration') {
    return (
      <ObservationTime
        className="observation__field"
        label={label}
        dateTime={state}
        handleChange={handleChange}
        setTimeError={setTimeError}
        fieldSchema={fieldSchema}
        startServiceDateTime={driveLog?.realized_date_start}
        displaySeconds={true}
      />
    );
  }

  if (delay.includes(fieldName)) {
    return (
      <ObservationDelay
        className={className}
        value={state}
        title={label}
        handleChange={handleChange}
        validator={validator}
        fieldSchema={fieldSchema}
      />
    );
  }

  if (checkbox.includes(fieldName)) {
    return <ObservationCheckbox className={className} value={state} handleChange={handleChange} />;
  }

  if (reminderText.includes(fieldName)) {
    return <ObservationReminderText className={className} text={label} />;
  }

  return null;
};

ObservationFields.propTypes = {
  line: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.object]),
  handleChange: PropTypes.func,
  mandatory: PropTypes.bool,
  validator: PropTypes.func,
  repeat: PropTypes.bool,
  setTimeError: PropTypes.func,
  driveLog: PropTypes.object.isRequired,
  observationFiles: PropTypes.array,
  setObservationFiles: PropTypes.func,
  observationId: PropTypes.string,
  maxLength: PropTypes.number,
  allFields: PropTypes.object,
};

export default ObservationFields;